import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {RelatedEntitiesWidgetController} from "../related-entities-widget.controller";

export class RelatedEntitiesWidgetProps extends BaseModuleProps {
  controller: RelatedEntitiesWidgetController;
  competitorId: Number;
  competitionId: Number;
  athleteId: Number;
}
